import { Item } from '@types'

export default function getMorphsValidValue(morph: Item['morphs'][number], defaultValue: number) {
  const max = morph.max
  const min = morph.min
  if (max === min) {
    if (defaultValue > max || defaultValue < min) {
      return max
    }
  }
  if (defaultValue === 0) {
    return min
  }
  if (max < defaultValue) {
    return max
  }
  if (min > defaultValue) {
    return min
  }
  return defaultValue
}
